import { useDrag } from '../../hooks/useDrag';
import { useIsRTL } from '../../locale';
export function useResizable(props) {
  const ref = props.ref;
  const isRTL = useIsRTL();
  const {
    startDrag,
    abortDrag,
    isDragging
  } = useDrag({
    onDrag: (_e, position) => {
      const node = ref.current;
      const rect = node.getBoundingClientRect();
      const newDimensions = {
        width: isRTL ? rect.width - position.deltaX : rect.width + position.deltaX,
        height: rect.height + position.deltaY
      };
      props.onResize(newDimensions);
    },
    onDragEnd: (_e, position) => {
      const node = ref.current;
      const rect = node.getBoundingClientRect();
      const newDimensions = {
        width: isRTL ? rect.width - position.deltaX : rect.width + position.deltaX,
        height: rect.height + position.deltaY
      };
      props.onResize(newDimensions);
    }
  });
  const onArrowKeyResize = e => {
    const node = ref.current;
    const rect = node.getBoundingClientRect();
    let newDimensions;
    switch (e.key) {
      case 'ArrowLeft':
        newDimensions = {
          width: isRTL ? rect.width + 5 : rect.width - 5,
          height: rect.height
        };
        props.onResize(newDimensions);
        break;
      case 'ArrowRight':
        newDimensions = {
          width: isRTL ? rect.width - 5 : rect.width + 5,
          height: rect.height
        };
        props.onResize(newDimensions);
        break;
      case 'ArrowUp':
        newDimensions = {
          width: rect.width,
          height: rect.height - 5
        };
        props.onResize(newDimensions);
        break;
      case 'ArrowDown':
        newDimensions = {
          width: rect.width,
          height: rect.height + 5
        };
        props.onResize(newDimensions);
        break;
    }
  };
  return {
    startResize: e => {
      if (e.button !== 0) return;
      startDrag([e.clientX, e.clientY]);
      e.preventDefault();
    },
    onArrowKeyResize,
    abortResize: abortDrag,
    isDragging
  };
}
//# sourceMappingURL=useResizable.js.map